import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchCategory} from 'sr/utils/api/fetchCategory'
export const fetchCategoryType = createAsyncThunk(
  'categoryType/fetchCategoryType',
  async (payload: any) => {
    const response = await fetchCategory({...payload, limit: 10000})
    return {
      data: response,
      totalCategories: response.totalResults || response.results?.length || 0,
      categoryMap: (response.results || []).reduce<Record<string, string>>((acc: any, category: any) => {
        acc[category.id] = category.name
        return acc
      }, {}),
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { categoryType } = getState() as { categoryType: { status: string } }
      return categoryType.status !== 'succeeded' && categoryType.status !== 'loading'
    },
  }
)
